import { render, staticRenderFns } from "./main-judgment.vue?vue&type=template&id=389a958e&scoped=true&"
import script from "./main-judgment.vue?vue&type=script&lang=js&"
export * from "./main-judgment.vue?vue&type=script&lang=js&"
import style0 from "./main-judgment.vue?vue&type=style&index=0&id=389a958e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a958e",
  null
  
)

export default component.exports